module.exports = __webpack_public_path__ + "static/c446bba479e806b81720ab3bb8f85cc241ba816981f525b8e94a1fb0ce760765-5c0d0d11ffb256b5dc66ef6b24411c23.png";